export const BASE_URL = "https://bitmart-opj5.onrender.com";